import {AreaFragmentDto, FaceDto, SectionFragmentDto} from "@hec/api-dtos";

export const GetChildrenForAreaFragments = (face: FaceDto, areaFragment: AreaFragmentDto): SectionFragmentDto[] => {
  const result = face.sectionFragments.filter(x=> (areaFragment.childSectionFragmentsIds ?? []).indexOf(x?.id ?? '') !== -1) ?? [];
  return result;
}
